import React from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";
const ReportsGenericTooltip = (props) => {
    return (React.createElement("div", { className: props.externalClassName },
        React.createElement(OverlayTrigger, { trigger: ["hover", "focus"], key: props.placement, placement: props.placement, overlay: React.createElement(Popover, { id: `popover-positioned-top` },
                React.createElement(Popover.Body, { className: "dash-popover-body" },
                    React.createElement("p", { className: "dash-toolbody" },
                        " ",
                        props.toolTipText))) },
            React.createElement("div", { className: "assetClassBgBlue" },
                React.createElement("p", { className: "assetClassBgBlue_value" }, props.badgevalue)))));
};
export default ReportsGenericTooltip;
